// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import {perr} from 'hola_pub_util';
import etask from 'zetask';
import {qs_parse} from 'zurl';
import {retry_et} from './retry_et';

const qs_o = ()=>qs_parse(window.location.search.substr(1), {safe: true});
const qs = qs_o();
export const perr_data = {
    user: null,
    uuid: null,
    appid: null,
    campaign: null,
};
export const vpn_perr = (id: string, info?: object_of<any>, fh?: string)=>{
    return etask('perr', function*(){
        info = info||{};
        const {user, uuid, appid, campaign} = perr_data;
        const opt:any = {id, info, filehead: fh, uuid: uuid||qs.uuid,
            appid: appid||qs.appid, campaign: campaign||qs.campaign};
        opt.ver = qs.app_ver;
        if (user)
        {
            info.user_id = user._id;
            opt.hola_uid = info.hola_uid = user.hola_uid;
            info.uuid = uuid;
        }
        yield retry_et(()=>perr(opt), 5);
    });
};
